import type { FaireProductEntity } from "../../entity_types/product";

export const p_daqrjq26mr: FaireProductEntity = {
  token: "p_daqrjq26mr",
  type: "product",
  name: "LM-TP1000- PRINT BABY DOLL TOP SS-  WHITE CAMO",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/db60e673e5d00bc8906ac7a1014df21fa705964b8e1c538a0078374ba9918683.jpeg",
  galleryImageUrls: [],
  priceDollars: 14.5,
  description: "This lightweight women's tee from Girlie Girl Originals features a playful white camo print and a baby doll silhouette that adds casual charm to outfits. Designed for easy layering and effortless style, it brings an approachable look to casual wardrobes and boutique collections.",
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:52.476Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
